import { ShieldAlert } from "lucide-react";

export default function HindiWarning({ compact = false }) {
  return (
    <div
      data-testid="hindi-no-cash-warning"
      className={`flex items-start gap-3 rounded-xl border border-orange-300 bg-orange-50 ${compact ? "p-3" : "p-4"}`}
    >
      <ShieldAlert className="text-orange-600 shrink-0 mt-0.5" size={compact ? 18 : 22} />
      <div className="text-sm">
        <p className="font-hindi text-orange-900 font-semibold leading-snug">
          कृपया किसी भी worker को नगद पैसे न दें। केवल Karmivo के official online payment gateway से ही भुगतान करें।
        </p>
        <p className="text-orange-800/80 mt-1">
          Please do not pay any worker in cash. Pay only through Karmivo's official online payment gateway.
        </p>
      </div>
    </div>
  );
}
